<template>
  <v-card flat class="pa-4">
    <!-- Snackbar -->
    <v-snackbar v-model="mensaje.snackbar" :timeout="mensaje.timeout" :color="mensaje.color" text top right>
      {{ mensaje.text }}
      <template v-slot:action="{ attrs }">
        <v-btn :color="mensaje.colorBtn" text v-bind="attrs" @click="mensaje.snackbar = false">Cerrar</v-btn>
      </template>
    </v-snackbar>

    <div v-if="loading" class="text-center pa-6">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      <p class="mt-2 grey--text">Cargando datos...</p>
    </div>

    <div v-else>
      <!-- Título según estado -->
      <h3 class="mb-1">{{ yaRegistrado ? 'Mis Datos de Vendedor' : 'Registrarme como Vendedor' }}</h3>
      <p class="caption grey--text mb-4">
        {{ yaRegistrado ? 'Edita tu información de vendedor.' : 'Completa el formulario para registrarte como vendedor en la plataforma.' }}
      </p>

      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="vendedor.nombre"
                label="Nombre"
                outlined dense
                :rules="[rules.required]"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="vendedor.apellido"
                label="Apellido"
                outlined dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="vendedor.identificador"
                label="Identificador"
                outlined dense disabled
                hint="Se asigna automáticamente de tu usuario"
                persistent-hint
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="vendedor.numero_documento"
                label="Número de Documento"
                outlined dense
                type="number"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="vendedor.fecha_nacimiento"
                label="Fecha de Nacimiento"
                type="date"
                outlined dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="vendedor.celular"
                label="Celular"
                outlined dense
              />
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="vendedor.direccion"
                label="Dirección"
                outlined dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="vendedor.correo_principal"
                label="Correo Principal"
                type="email"
                outlined dense
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="vendedor.correo_secundario"
                label="Correo Secundario"
                type="email"
                outlined dense
              />
            </v-col>
          </v-row>
        </v-container>

        <v-btn color="success" class="mr-4" :loading="saving" @click="guardar">
          <v-icon left>{{ yaRegistrado ? 'mdi-content-save' : 'mdi-account-plus' }}</v-icon>
          {{ yaRegistrado ? 'Guardar Cambios' : 'Registrarme' }}
        </v-btn>

        <v-btn color="error" text @click="cancelar" v-if="!yaRegistrado">
          Limpiar
        </v-btn>
      </v-form>
    </div>
  </v-card>
</template>

<script>
import vendedorService from '@/services/tienda/vendedorService.js';

export default {
  name: 'MiVendedor',
  data() {
    return {
      loading: true,
      saving: false,
      valid: true,
      yaRegistrado: false,
      vendedor: {
        nombre: '',
        apellido: '',
        identificador: '',
        numero_documento: '',
        fecha_nacimiento: '',
        direccion: '',
        celular: '',
        correo_principal: '',
        correo_secundario: '',
      },
      rules: {
        required: v => !!v || 'Campo requerido',
      },
      mensaje: {
        snackbar: false,
        text: '',
        color: '',
        colorBtn: '',
        timeout: 4000,
      },
    };
  },
  mounted() {
    this.cargarMiVendedor();
  },
  methods: {
    cargarMiVendedor() {
      this.loading = true;
      vendedorService.miVendedor()
        .then(res => {
          if (res.data.status) {
            this.vendedor = res.data.vendedor;
            this.yaRegistrado = true;
          }
        })
        .catch(err => {
          if (err.response && err.response.status === 404) {
            // No tiene vendedor — mostrar formulario de registro
            this.yaRegistrado = false;
            // Pre-rellenar identificador del store
            this.vendedor.identificador = this.$store.state.identificadorUsuario || '';
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    guardar() {
      if (!this.$refs.form.validate()) return;

      this.saving = true;

      const promesa = this.yaRegistrado
        ? vendedorService.actualizarMiVendedor(this.vendedor)
        : vendedorService.registrarMiVendedor(this.vendedor);

      promesa
        .then(res => {
          this.showMsg(res.data.message || 'Operación exitosa', 'success');
          if (!this.yaRegistrado) {
            this.yaRegistrado = true;
            this.vendedor = res.data.vendedor;
          }
        })
        .catch(err => {
          const errors = err.response?.data?.errors;
          const msg = errors ? errors.join(', ') : (err.response?.data?.message || 'Error');
          this.showMsg(msg, 'error');
        })
        .finally(() => {
          this.saving = false;
        });
    },
    cancelar() {
      this.vendedor = {
        nombre: '',
        apellido: '',
        identificador: this.$store.state.identificadorUsuario || '',
        numero_documento: '',
        fecha_nacimiento: '',
        direccion: '',
        celular: '',
        correo_principal: '',
        correo_secundario: '',
      };
      this.$refs.form?.resetValidation();
    },
    showMsg(text, type) {
      this.mensaje.text = text;
      this.mensaje.color = type === 'success' ? 'success' : 'error';
      this.mensaje.colorBtn = type === 'success' ? 'green darken-1' : 'red darken-1';
      this.mensaje.snackbar = true;
    },
  },
};
</script>
